import { render, staticRenderFns } from "./ManagementCand.vue?vue&type=template&id=4bfd54a1&"
import script from "./managementCand.js?vue&type=script&lang=js&"
export * from "./managementCand.js?vue&type=script&lang=js&"
import style0 from "./ManagementCand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports